<div class="stream-player" id="stream-player">
    <div class="video-container">
        <video #video class="azuremediaplayer amp-flush-skin amp-big-play-centered live-video" tabindex="0">
            <p class="amp-no-js">
                To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5
                video
            </p>
        </video>
    </div>
</div>